import * as umServinceURL from './umServiceURL'
import useCallApi from '../../utilities/axios'

export type TransT = {
    th: string
    en: string
}

export type OptType = {
    label: string
    value: string
}

export type CommitteesType = {
    id: number
    academicPosition: TransT
    title: TransT
    isPhD: boolean
    name: TransT
    titleID: number | null
}

export type ReviewerResponseType = {
    projectID: number
    projectNumber: string
    projectName: TransT
    projectType: {
        id: string
        name: TransT
    }
    name: TransT
    title: TransT
    academicPosition: TransT
    isPhD: boolean
    committees: CommitteesType[]
    laypersons: CommitteesType[]
    titleID: number
    receiveDate: string
}

export type ReviewerSearchProps = {
    userID?: number
    keyword?: string
    projectType?: number
    startDate: string
    endDate: string
}

export type ReviewerSearchForm = {
    keyword?: string
    projectType?: number
    startDate: Date | string
    endDate: Date | string
}

const useSearchReviewer = () => {
    const callApi = useCallApi()

    const getReviewerData = async (values: ReviewerSearchProps) => {
        const { data } = await callApi.axiosPost<ReviewerResponseType[]>({
            url: umServinceURL.getResultReviewer,
            params: values,
        })
        return data
    }

    return { getReviewerData }
}

export default useSearchReviewer
